// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empty-plannings {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  text-align: center;
}
.empty-plannings__img {
  max-width: 85%;
  margin: 0 auto;
}
.empty-plannings__title {
  font-size: 15px;
  font-weight: 700;
  color: var(--sebrae-blue);
}
.empty-plannings__subtitle {
  font-size: 12px;
  font-weight: 400;
  color: var(--sebrae-dark-gray3);
  margin-top: 8px;
}
@media screen and (min-width: 768px) {
  .empty-plannings__img {
    max-width: 100%;
  }
  .empty-plannings__title {
    font-size: 19px;
  }
  .empty-plannings__subtitle {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/empty-plannings/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AACF;AACE;EACE,cAAA;EACA,cAAA;AACJ;AACE;EAEI,eAAA;EACA,gBAAA;EAEF,yBAAA;AADJ;AAGE;EAEI,eAAA;EACA,gBAAA;EAEF,+BAAA;EACA,eAAA;AAHJ;AAME;EACE;IACE,eAAA;EAJJ;EAME;IACE,eAAA;EAJJ;EAME;IACE,eAAA;EAJJ;AACF","sourcesContent":[".empty-plannings {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 24px;\n  text-align: center;\n\n  &__img {\n    max-width: 85%;\n    margin: 0 auto;\n  }\n  &__title {\n    font: {\n      size: 15px;\n      weight: 700;\n    }\n    color: var(--sebrae-blue);\n  }\n  &__subtitle {\n    font: {\n      size: 12px;\n      weight: 400;\n    }\n    color: var(--sebrae-dark-gray3);\n    margin-top: 8px;\n  }\n\n  @media screen and (min-width: 768px) {\n    &__img {\n      max-width: 100%;\n    }\n    &__title {\n      font-size: 19px;\n    }\n    &__subtitle {\n      font-size: 16px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
